import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const SKEY = "z6_anon_session";
const sessionId = () => {
  let s = sessionStorage.getItem(SKEY);
  if (!s) { s = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); sessionStorage.setItem(SKEY, s); }
  return s;
};
const sizeClass = () => (window.innerWidth < 640 ? "phone" : window.innerWidth <= 1366 ? "tablet" : "desktop");

// Privacy-safe analytics: anonymous session id, event type, device size class. Never names, health answers, allergies or free text.
// One send per event + page view: remounts (page transitions) within a few seconds don't double-count.
const recent = new Map();
export const track = (type, extra = {}) => {
  const k = JSON.stringify([type, extra, window.location.pathname + window.location.search]);
  if (Date.now() - (recent.get(k) || 0) < 3000) return;
  recent.set(k, Date.now());
  api.post("/events", { type, session: sessionId(), size: sizeClass(), ...extra }).catch(() => {});
};
export const newAnonSession = () => sessionStorage.removeItem(SKEY);

export const useTrack = (type, extra, when = true) => {
  const sent = useRef(null);
  const key = JSON.stringify([type, extra]);
  useEffect(() => {
    if (!when || sent.current === key) return;
    sent.current = key;
    track(type, extra);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, when]);
};
